import styled from 'styled-components'

export const EqualSizeSegments = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 5px 10px 10px;

  & > .segment {
    display: flex;
    flex: 1;
    box-shadow: none;
    margin-top: 0;

    &:first-child {
      margin-top: 5px;
    }
  }
`

export const SegmentGroup = styled.section`
  display: flex;
  flex: 1;
  width: 100%;

  & .segments {
    border-top: none;
    flex: 1;
    display: flex;
    width: 100%;
    overflow: ${(props) => (props.visableOverflow ? 'visable' : 'none')};
    box-shadow: none !important;
    border-bottom: none !important;
    & > .segment {
      padding: 0;
    }
  }
`

export const FakeSegment = styled.section`
  & .segment {
    padding: 0;
    margin: 0;
    box-shadow: none;
    border-top: none;
  }
`

export const FlexSegment = styled.div`
  flex: 1;
  position: relative;
  overflow: auto;
`
